// Route/ProfessionalRoute.jsx
import { useSelector } from "react-redux";
import { Navigate } from "react-router-dom";

const ProfessionalRoute = ({ children }) => {
  const user = useSelector((state) => state.auth.userInfo);
  const accessToken = useSelector((state) => state.auth.accessToken);

  if (!accessToken) return <Navigate to="/auth/login" />;
  if (user?.user_type?.toLowerCase() !== "professional") {
    return <Navigate to="/admin/dashboard" replace />;
  }
  return children;
};
export default ProfessionalRoute;
